import { Constants } from '@leverege/molten';
import VehiclesBulkCreateHook from './VehiclesBulkCreateHook';
import PaymentsBulkCreateHook from './PaymentsBulkCreateHook';
const {
  BLUEPRINTS_PROCESSOR
} = Constants;
export default {
  install(molten) {
    molten.addPlugin(BLUEPRINTS_PROCESSOR, VehiclesBulkCreateHook);
    molten.addPlugin('BulkCreateHook', PaymentsBulkCreateHook);
  }
};